import React from 'react'

const NewsPage = () => {
  return (
    <div>
      
    </div>
  )
}

export default NewsPage
